<h1 mat-dialog-title class="text-center">{{ 'Intellitrailer.Rental.Dialog.ReturnFarAway.ActionRequired' | translate : 'Action required'}}</h1>
<div mat-dialog-content>
  @if(!returnConfirmation) {
  <p class="text-center">{{ 'Intellitrailer.Rental.ReturnFarAway.TextReturnInfo' | translate : 'It looks like you are not at the return location yet. Please go to {0} to return your trailer' : [this.data.location] }}</p>
  <div #gmap id="map"></div>
  <br />
  <p class="text-center">{{ 'Intellitrailer.Rental.ReturnFarAway.NoteReturnInfo1' | translate : 'Please note that you should be at the location to return the trailer.'}}</p>
  }
  @else {
  <p class="text-center">{{ 'Intellitrailer.Rental.ReturnFarAway.TextReturnConfirmInfo1' | translate : 'It is important that you deliver the trailer back at the correct place. Please confirm that you are back on site' }}</p>
  }
</div>
<div class="btn-container" mat-dialog-actions>
  @if(!returnConfirmation) {
  <button mat-button mat-raised-button color="primary" (click)="understand()">{{ 'Intellitrailer.Rental.Dialog.ReturnFarAway.btnIUnderstand' | translate : 'I understand'}}</button>
  <div class="link" (click)="atLocation()"> {{ 'Intellitrailer.Rental.Dialog.ReturnFarAway.btnIamAtlocation' | translate : 'I am at the location' }}</div>
  }
  @else {
  <button mat-button mat-raised-button color="primary" (click)="confirmReturn()">{{ 'Intellitrailer.Rental.Dialog.ReturnFarAway.btnIConfirm' | translate : 'I confirm'}}</button>
  <button mat-button mat-raised-button color="accent" (click)="understand()">{{ 'Intellitrailer.Rental.Dialog.ReturnFarAway.btnCancel' | translate : 'Cancel'}}</button>
  }
</div>
